import { BASEJUMP_API_URL, BASEJUMP_API_BASE_PATH } from "../constants";

export class ApiError extends Error {
  constructor(message, status) {
    super(`${message} (status: ${status})`);
    this.name = "ApiError";
    this.status = status;
  }
}

export class ApiClient {
  constructor(baseURL, baseOptions = {}) {
    this.baseURL = baseURL;
    this.baseOptions = baseOptions;
  }

  async fetch(path, options = {}) {
    try {
      const response = await fetch(`${this.baseURL}${path}`, {
        ...this.baseOptions,
        ...options,
      });
      if (!response.ok) {
        throw new ApiError("API request failed", response.status);
      }
      if (response.status === 204) {
        return null; // No content
      }
      return response.json();
    } catch (error) {
      if (error instanceof ApiError) {
        throw error; // Re-throw known API errors
      }
      throw new ApiError("Network or server error", 500); // Generic error for other cases
    }
  }
}

export const apiClient = new ApiClient(
  `${BASEJUMP_API_URL}${BASEJUMP_API_BASE_PATH}`
);
